import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Container,
  Typography,
  Grid,
  Box,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { FaUser } from "react-icons/fa";
import toast, { Toaster } from 'react-hot-toast';  // Import react-hot-toast for toasts
import thankyouAnimation from "../../assets/images/NewIcon/Animation - 1720520813759.json";
import aboutImage from "../../assets/FlipImages/contact.webp";
import "./ConatctForm.css";
import contact from "../../assets/images/contact/contactimg.mp4";
import contact1 from "../../assets/images/contact/contact1.mp4";
import contact2 from "../../assets/images/contact/contact2.mp4";
import contact3 from "../../assets/images/contact/contact3.mp4";
import contact4 from "../../assets/images/contact/contact4.mp4";
import emailjs from "emailjs-com";  // Import emailjs

const countryCodes = [
  { code: "+1", name: "United States" },
  { code: "+44", name: "United Kingdom" },
  { code: "+91", name: "India" },
  { code: "+971", name: "UAE" },
  { code: "+61", name: "Australia" },
  { code: "+49", name: "Germany" },
  { code: "+33", name: "France" },
  { code: "+81", name: "Japan" },
  { code: "+86", name: "China" },
  { code: "+55", name: "Brazil" },
  // Add more country codes as needed
];

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [resultTrue, setResultTrue] = useState(false);
  const [resultFalse, setResultFalse] = useState(false);

  const onSubmit = async (data) => {
    try {
      const templateParams = {
        full_name: data.fullName,  // Mapping to template field
        email: data.email,         // Mapping to template field
        mobile_number: `${data.countryCode}${data.phone}`,  // Mapping to template field
        subject: data.subject,     // Mapping to template field
        message: data.message,     // Mapping to template field
      };

      const response = await emailjs.send(
        'service_t942lbq',
        'template_okuq2vb', 
        templateParams,
        'Gix4LeAYyCRomDCbM' 
      );

      if (response.status === 200) {
        setSubmitted(true);
        setResultTrue(true);
        setTimeout(() => {
          setSubmitted(false);
          setResultTrue(false);
          toast.success("Thank you for submitting your information!");  // Show success toast
          reset(); // Reset the form fields
        }, 1000);
      } else {
        setResultFalse(true);
        setTimeout(() => {
          setResultFalse(false);
          toast.error("Something went wrong, please try again later!");  // Show error toast
          reset(); // Reset the form fields
        }, 1000);
      }
    } catch (error) {
      setResultFalse(true);
      setTimeout(() => {
        setResultFalse(false);
        toast.error("Something went wrong, please try again later!");  // Show error toast
        reset(); // Reset the form fields
      }, 1000);
    }
  };

  return (
    <div style={{ backgroundColor: "#f0f0f0", padding: "5px" }}>
      <Container maxWidth="md" className="my-5">
        <div className="row text-center justify-content-center align-content-center">
          <div className="col-lg-12">
            <span
              style={{
                fontWeight: "bold",
                color: "#072f5f",
                fontSize: "25px",
              }}
            >
            CONTACT US
            </span>
            <h2
              className="title text-uppercase testword"
              style={{
                fontWeight: "bold",
                fontSize: "30px",
                marginTop: "10px",
                color: "#072f5f",
              }}
            >
              Don't Hesitate To Contact Us, Say Hello!
            </h2>
          </div>
        </div>
        <br />
        <Grid container spacing={4} alignItems="center">
          <Grid item md={6}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField
                fullWidth
                label="Full Name"
                margin="normal"
                {...register("fullName", { required: "Full Name is required" })}
                error={!!errors.fullName}
                helperText={errors.fullName ? errors.fullName.message : ""}
              />
              <TextField
                fullWidth
                label="Email"
                margin="normal"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Invalid email address",
                  },
                })}
                error={!!errors.email}
                helperText={errors.email ? errors.email.message : ""}
              />
              <Box display="flex" alignItems="center" gap="1rem">
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="country-code-label">Code</InputLabel>
                  <Controller
                    name="countryCode"
                    control={control}
                    defaultValue="+91"
                    rules={{ required: "Country code is required" }}
                    render={({ field }) => (
                      <Select
                        labelId="country-code-label"
                        label="Code"
                        {...field}
                      >
                        {countryCodes.map((country) => (
                          <MenuItem key={country.code} value={country.code}>
                            {country.code} ({country.name})
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
                <TextField
                  fullWidth
                  label="Mobile Number"
                  margin="normal"
                  {...register("phone", {
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^[0-9]{10}$/, 
                      message: "Invalid mobile number",
                    },
                  })}
                  error={!!errors.phone}
                  helperText={errors.phone ? errors.phone.message : ""}
                  style={{ marginBottom: "15px" }}
                />
              </Box>
              <TextField
                fullWidth
                label="Subject"
                margin="normal"
                {...register("subject", { required: "Subject is required" })}
                error={!!errors.subject}
                helperText={errors.subject ? errors.subject.message : ""}
              />
              <TextField
                fullWidth
                label="Message"
                margin="normal"
                multiline
                rows={4}
                {...register("message", { required: "Message is required" })}
                error={!!errors.message}
                helperText={errors.message ? errors.message.message : ""}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    {...register("terms", {
                      required: "You must accept the terms and conditions",
                    })}
                  />
                }
                label={
                  <>
                    I accept the&nbsp;
                    <Link
                      to="/privacypolicy"
                      style={{ textDecoration: "none" }}
                    >
                      terms and conditions
                    </Link>
                  </>
                }
              />
              {errors.terms && (
                <Typography color="error">{errors.terms.message}</Typography>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  marginTop: "16px",
                  backgroundColor: "rgb(7, 47, 95)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "black",
                    color: "white",
                  },
                }}
              >
                Send Message
              </Button>
            </form>
          </Grid>
          <Grid item md={6} textAlign="center">
            <video
              className="img-center unique-img-fluid unique-rounded"
              src={contact3}
              height="300"
              width="500"
              alt="About"
              loop
              autoPlay
              muted
            >
              Your browser does not support the video tag.
            </video>
          </Grid>
        </Grid>
      </Container>

      {/* Toast Notifications */}
      <Toaster />
    </div>
  );
};

export default ContactForm;
